<template>
  <div>
    <v-dialog class="paper-dialog" title="Edit Paper" :visible.sync="dialogVisible" width="65vw" @open="onOpen"
      @close="onClosed">
      <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" label-width="190px" v-loading="loading"
        element-loading-text="loading...">
        <el-form-item label="" prop="">
            <p class="right-find">
            <i class="el-icon-warning-outline"></i>请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站：
            <a href="https://www.rightfind.com" target="_blank">https://www.rightfind.com</a>
          </p>
        </el-form-item>
        <el-form-item label="Content Category" prop="categoryId">
          <div class="cate-select-add">
            <el-select placeholder="Please select content category" v-model="form.categoryId">
              <el-option v-for="(item, index) in categoryList" :label="item.CategoryName" :value="item.PaperCategoryID"
                :key="index">
                <div class="select-option-item" :title="item.CategoryName">
                  {{ item.CategoryName }}
                </div>
              </el-option>
            </el-select>
            <el-button icon="el-icon-plus" @click="showCateDialog" />
          </div>
        </el-form-item>
        <el-form-item label="Short Title" prop="shortTitle">
          <el-input placeholder="Please input short title" v-model="form.shortTitle" maxlength="100" />
        </el-form-item>
        <el-form-item label="Search Term" prop="searchTerm">
          <el-input placeholder="Please input search term" v-model="form.searchTerm" maxlength="40" />
        </el-form-item>
        <el-form-item label="Security Level" prop="levelID">
          <el-select v-model="form.levelID" placeholder="Please select security level">
            <el-option v-for="(item, index) in securityLevels" :label="item.Name" :value="item.Id" :key="index" />
          </el-select>
          <p class="security-level">
            <i class="el-icon-warning-outline"></i>本平台禁止传输Orange/Red
            CCI文件。
          </p>
        </el-form-item>
        <el-form-item class="replace-file" label="PDF Attached" prop="isReplace">
          <el-checkbox v-model="form.isReplace" />
          <div class="replace-file-tip">
            <span>Replace Uploaded File ?</span>
            <a :href="previewUrl" target="_blank" :title="previewName">
              {{ previewName }}
            </a>
          </div>
        </el-form-item>
        <el-form-item label="Upload PDF">
          <FileUpload ref="fileUpload" action="/content/uploadFile" accept=".PDF,.pdf"
            message="Only PDF file can be uploaded" @success="handleSuccess" @fail="handleFail" />
          <div v-if="uploadFile" class="upload-file">
            <a :href="uploadFile.url" target="_blank" :title="fileName">
            <!-- <a :href="`/online-preview/${uploadFile.code}`" target="_blank" :title="fileName"> -->
              <i class="el-icon-document"></i>
              {{ fileName }}
            </a>
            <span @click="uploadFile = null">
              <i class="el-icon-close"></i>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="Allow Full Article Request" prop="fullPaperRequest">
          <el-radio-group v-model="form.fullPaperRequest">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Content" prop="paperContent" class="editor">
          <TinymceEditor v-if="visible" ref="vTinymce" v-model="form.paperContent" :height="300"
            @input="paperContentValidator" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="push-footer">
        <el-button type="primary" @click="onSubmit"> Submit </el-button>
        <el-button plain @click="onClosed"> Cancel </el-button>
      </div>
    </v-dialog>
    <NewCategoryDialog :visible.sync="addCategoryDialogVisible" @success="onNewCateSuccess" @closed="onNewCateClosed" />
  </div>
</template>
<script>
import TinymceEditor from "../../components/tinymce-editor";
import NewCategoryDialog from "./new-category-dialog.vue";
import FileUpload from "../../components/file-upload";
import { trimValidate } from "../../utils/validator";
export default {
  name: "new-paper-dialog",
  components: { TinymceEditor, NewCategoryDialog, FileUpload },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      seList: [],
      categoryList: [],
      securityLevels: [],
      form: {
        seId: null,
        categoryId: "",
        shortTitle: "",
        searchTerm: "",
        isReplace: false,
        levelID: "",
        fullPaperRequest: 1,
        paperContent: "",
      },
      formRules: {
        seId: [
          { required: true, message: "Please select SE/CE", trigger: "change" },
        ],
        categoryId: [
          {
            required: true,
            message: "Please select content category",
            trigger: "change",
          },
        ],
        shortTitle: [
          {
            required: true,
            validator: trimValidate("Please input short title"),
            trigger: "blur",
          },
        ],
        searchTerm: [
          {
            required: true,
            validator: trimValidate("Please input search term"),
            trigger: "blur",
          },
        ],
        levelID: [
          {
            required: true,
            message: "Please select security level",
            trigger: "change",
          },
        ],
        fileName: [
          { required: true, message: "It must be filled", trigger: "blur" },
        ],
        uploadName: [
          { required: true, message: "It must be filled", trigger: "blur" },
        ],
        fullPaperRequest: [
          {
            required: true,
            message: "Please check the full paper request radio button",
            trigger: "blur",
          },
        ],
        paperContent: [
          {
            required: true,
            message: "Please input content",
            trigger: "change",
          },
        ],
      },
      hidePaperDialog: false,
      addCategoryDialogVisible: false,
      uploadFile: null,
      previewUrl: "",
      previewName: "",
      loading: false,
    };
  },
  computed: {
    fileName() {
      return this.uploadFile ? this.uploadFile.file.name : null;
    },
    uploadName() {
      return this.uploadFile ? this.uploadFile.fileNameSave : null;
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      if (!this.hidePaperDialog) {
        this.uploadFile = null;
        this.previewUrl = "";
        this.previewName = "";
        this.$refs.fileUpload.reset();
        this.$refs.form.resetFields();
        this.$emit("update:data", null);
        this.$emit("update:visible", false);
      }
    },
    onOpen() {
      if (this.data && !this.hidePaperDialog) {
        this.initForm();
      }
      if (this.hidePaperDialog) {
        this.hidePaperDialog = false;
      }
    },
    initForm() {
      this.loading = true;
      this.$axios
        .all([
          this.axios.get("/content/seList"),
          this.axios.get("/content/categoryList"),
          this.axios.get("/content/securityLevel"),
        ])
        .then((res) => {
          if (res[0].code === 200) {
            this.seList = res[0].data;
          } else {
            this.$message.error(res[0].msg);
          }
          if (res[1].code === 200) {
            this.categoryList = res[1].data;
          } else {
            this.$message.error(res[1].msg);
          }
          if (res[2].code === 200) {
            this.securityLevels = res[2].data;
          } else {
            this.$message.error(res[2].msg);
          }
          this.$nextTick(() => {
            const {
              SEID,
              PaperCategoryID,
              ShortTitle,
              FullPaperRequest,
              SearchTerm,
              PaperContent,
              FileName,
              // Attachment,
              AttachmentPath,
              levelID,
            } = this.data;
            this.form.seId = SEID;
            this.form.categoryId = PaperCategoryID;
            this.form.shortTitle = ShortTitle;
            this.form.fullPaperRequest = FullPaperRequest;
            this.form.searchTerm = SearchTerm;
            this.form.paperContent = PaperContent;
            this.previewName = FileName;
            this.previewUrl = `${AttachmentPath}`;
            // this.previewUrl = `${process.env.VUE_APP_SERVER}/upload/paper/${Attachment}`;
            this.form.levelID = levelID;
          });
          this.loading = false;
        });
    },
    getCategoryList() {
      this.axios.get("/content/categoryList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.categoryList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    paperContentValidator() {
      const vTinymce = this.$refs.vTinymce;
      if (vTinymce) {
        const editor = vTinymce.getEditor();
        if (editor) {
          const text = editor.getContent({ format: "text" }).trim();
          const html = editor.getContent({ format: "html" });
          if (
            html.indexOf("video") === -1 &&
            html.indexOf("img") === -1 &&
            html.indexOf("table") === -1
          ) {
            if (text.length > 0) {
              this.$refs.form.clearValidate("paperContent");
            }
            if (text.length === 0 && this.visible) {
              this.$set(this.form, "paperContent", "");
              this.$refs.form.validateField("paperContent");
            }
          } else {
            this.$refs.form.clearValidate("paperContent");
          }
        }
      }
    },
    onSubmit() {
      this.paperContentValidator();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios
            .post("/content/updatePaper", {
              ...this.form,
              shortTitle: this.form.shortTitle.trim(),
              searchTerm: this.form.searchTerm.trim(),
              paperId: this.data.PaperID,
              fileName: this.fileName,
              uploadName: this.uploadName,
            })
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$message.success("Update content successfully");
                this.$emit("success");
                this.$emit("update:visible", false);
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleSuccess(file) {
      this.uploadFile = file;
      this.$message.success("Upload file successfully");
    },
    handleFail() {
      this.$message.error("Upload file failed");
    },
    showCateDialog() {
      this.hidePaperDialog = true;
      this.dialogVisible = false;
      this.addCategoryDialogVisible = true;
    },
    onNewCateSuccess(categoryId) {
      this.getCategoryList();
      this.form.categoryId = categoryId;
    },
    onNewCateClosed() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-dialog {
  ::v-deep .el-dialog__body {
    padding: 0;
    display: flex;
    max-height: 67vh;
  }
}

::v-deep {
  .select-option-item {
    max-width: 38vw;
  }
}

.push-footer {
  text-align: center;
}

.el-select+.el-button {
  margin-left: 10px;
}

.el-uploader {
  margin-right: 15px;
}

.upload-file {
  display: inline-flex;
  align-items: center;

  a {
    margin-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    overflow: hidden;
  }

  span {
    cursor: pointer;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: $theme-color;

    &:hover {
      color: #606266;
    }
  }
}

.el-form-item {
  margin-bottom: 15px !important;

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }

  &.replace-file {
    ::v-deep {
      .el-form-item__content {
        display: flex;
      }
    }
  }

  &.editor {
    margin-bottom: 0 !important;
    height: 315px;
  }

  .cate-select-add {
    width: 90%;
    display: flex;

    .el-select {
      flex: 1;
    }
  }

  .security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
}

.replace-file-tip {
  display: flex;

  span {
    margin: 0 10px;
  }

  a {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    overflow: hidden;
  }
}
</style>
